module.exports = __webpack_public_path__ + "img/2024-08-29c_5.52351186.jpg";